import {useEffect, useState} from 'react';
import {truncateText} from '@/utils/main/search';
import {decodeHtmlEntities} from '@/utils';
import {useSearchGlobalStatus} from '@/components/search/SearchProvider';

/**
 *
 * @param stopWordInfo props 내가 검색한 검색 키워드 정보
 * @param live props 라이브 목록
 * @param extraLive props 추천 라이브 목록
 * @return {unknown}
 * @constructor
 */
const LiveNoResultSearchKeywordGroup = ({live, extraLive}) => {
  const {extraOriginKeyword, removeSuggest} = useSearchGlobalStatus();
  const [searchWord, setSearchWord] = useState('');

  useEffect(() => {
    // 100% 매칭하는 라이브 데이터는 없는데, 추천 LIVE 데이터만 있을경우
    if (live?.length < 1 && extraLive?.length > 0) {
      setSearchWord(extraOriginKeyword);
    }
  }, [extraOriginKeyword, live, extraLive]);

  return searchWord !== '' && removeSuggest ? (
    <div className='suggest_area'>
      <span className='ic_info'>i</span>
      <div className='result_txt'>
        <strong>&#39;{truncateText(searchWord)}&#39;</strong>
        <span>에 대한 LIVE 검색 결과가 없습니다.</span>
      </div>
    </div>
  ) : null;
};

export default LiveNoResultSearchKeywordGroup;
